import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DynamicPageBuilderTextboxComponent } from './dynamic-page-builder-textbox.component';
import { MaterialModule } from 'src/app/shared/material.module';
import { PageBuilderTextboxFormComponent } from './textbox-form/page-builder-textbox-form.component';

@NgModule({
    declarations: [
        PageBuilderTextboxFormComponent, DynamicPageBuilderTextboxComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
    ],
    exports: [
        DynamicPageBuilderTextboxComponent
    ],
    entryComponents: [
        DynamicPageBuilderTextboxComponent
    ]
})
export class PageBuilderTextboxModule {}